import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Heading from 'shopper/components/Heading';

import placeholder from 'lib/placeholder';

import OfferRowCard from './OfferRowCard';

const OfferComparator = ({
  gaEventCategory,
  className,
  offerId,
  offersToCompare,
}) => (
  <section className={twJoin('mb-8 grid gap-y-4 lg:mb-16', className)}>
    <Heading className="mb-2" size="size4">
      {placeholder('titles.compareToOtherOffers')}
    </Heading>
    {offersToCompare.map(({ id, price, redirect, store }) => (
      <OfferRowCard
        key={id}
        gaEventCategory={gaEventCategory}
        offerCompareId={id}
        offerId={offerId}
        offerPrice={price}
        redirectUrl={redirect}
        storeImage={store.image}
        storeName={store.name}
      />
    ))}
  </section>
);

OfferComparator.displayName = 'OfferComparator';

OfferComparator.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  offerId: PropTypes.number.isRequired,
  offersToCompare: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      redirect: PropTypes.string.isRequired,
      created: PropTypes.string.isRequired,
      store: PropTypes.shape({
        domain: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
};

export default OfferComparator;
